<template>
  <div ref="dialog" class="forum-next-dialog" role="dialog" aria-modal="true" :aria-label="label" tabindex="-1" @click.self="requestClose">
    <div class="forum-next-dialog__surface"><slot /></div>
  </div>
</template>
<script>
import { mountForumDialog } from '../services/forumDialog';
export default {
  name: 'ForumDialog', props: { label: { type: String, required: true }, requestClose: { type: Function, required: true } },
  beforeMount() { this.previousFocus = document.activeElement; },
  mounted() { this.releaseDialog = mountForumDialog(this.$refs.dialog, this.requestClose, this.previousFocus); },
  beforeDestroy() { if (this.releaseDialog) this.releaseDialog(); }
};
</script>
<style lang="scss">
.forum-next-dialog { position: fixed; z-index: var(--modern-layer-modal, 10040); top: var(--forum-dialog-top, 62px); left: 0; right: 0; height: var(--forum-dialog-height, calc(100dvh - 62px)); display: flex; background: rgba(10, 20, 30, .4); min-height: 0; }
.forum-next-dialog__surface { min-width: 0; width: 100%; height: 100%; overflow: auto; overscroll-behavior: contain; background: var(--modern-surface); color: var(--modern-text); padding: 16px 16px calc(20px + env(safe-area-inset-bottom, 0px)); }
@media (min-width: 768px) {
  .forum-next-dialog { padding: 24px; align-items: center; justify-content: center; }
  .forum-next-dialog__surface { height: auto; max-height: 100%; max-width: 800px; border: 1px solid var(--modern-border); border-radius: 12px; padding: 24px; }
}
</style>
